import _en from './translations/en.json.mjs';
import React__default from 'react';
import { useI18n } from '@shopify/react-i18n';
import { DeleteIcon } from '@shopify/polaris-icons';
import styles from './EditableLink.scss.mjs';
import { KeyboardNavigationOption } from '../KeyboardNavigation/components/KeyboardNavigationOption/KeyboardNavigationOption.mjs';
import { PlainAction } from '../PlainAction/PlainAction.mjs';

function EditableLink({
  url,
  icon,
  label,
  onEdit,
  onRemove
}) {
  const [i18n] = useI18n({
    id: 'EditableLink_rzdvi9',
    fallback: _en,
    translations(locale) {
      if (["cs", "da", "de", "es", "fi", "fr", "it", "ja", "ko", "nb", "nl", "pl", "pt-BR", "pt-PT", "sv", "th", "tr", "vi", "zh-CN", "zh-TW"].indexOf(locale) < 0) {
        return;
      }
      return import( /* webpackChunkName: "EditableLink_rzdvi9-i18n", webpackMode: "lazy-once" */`./translations/${locale}.json`).then(dict => dict && dict.default);
    }
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.EditableLink
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.Preview
  }, /*#__PURE__*/React__default.createElement(KeyboardNavigationOption, null, /*#__PURE__*/React__default.createElement(PlainAction, {
    slim: true,
    unstyled: true,
    truncate: true,
    external: true,
    icon: icon,
    content: label || url,
    accessibilityLabel: i18n.translate('EditableLink.Preview.accessibilityLabel'),
    url: url
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: styles.Actions
  }, /*#__PURE__*/React__default.createElement(KeyboardNavigationOption, null, /*#__PURE__*/React__default.createElement(PlainAction, {
    slim: true,
    unstyled: true,
    content: i18n.translate('EditableLink.Edit.content'),
    accessibilityLabel: i18n.translate('EditableLink.Edit.accessibilityLabel'),
    onAction: onEdit
  })), /*#__PURE__*/React__default.createElement(KeyboardNavigationOption, null, /*#__PURE__*/React__default.createElement(PlainAction, {
    slim: true,
    unstyled: true,
    accessibilityLabel: i18n.translate('EditableLink.Remove.accessibilityLabel'),
    icon: DeleteIcon,
    onAction: onRemove
  }))));
}

export { EditableLink };
